import React, {Component} from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {IFilter} from "../calendar/types";
import { styled } from '@mui/system';

const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
    verticalAlign: 'middle',
    fontFamily: 'Helvetica,sans-serif',
    textTransform: 'none',
    minWidth: '7rem',
    marginRight: '0.5rem',
    marginBottom: '0.5rem',
    '&.MuiToggleButtonGroup-grouped': {
        '&:not(:first-of-type), &:is(:first-of-type)' : {
            borderColor: 'inherit',
            borderRadius: '0.5rem',
            '&:hover': {
                backgroundColor: 'gray',
                color: 'white',
                borderColor: '#727272',
            },
            '&.Mui-selected': {
                backgroundColor: 'gray',
                color: 'white',
                borderColor: '#ccc',
                '&:hover': {
                    backgroundColor: '#bdbdbd',
                    color: 'white',
                },
            }
        },
    },
}));

const CustomToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    display: 'inline-block',
    textAlign: 'justify',
    verticalAlign: 'middle',
    marginBottom: '1rem',
    '@media (max-width: 768px)': {
        textAlign: 'center'
    }
}));

interface FilterButtonsProps {
    className?: string;
    filters: IFilter[];
    selectedFilters: IFilter[];
    onSelectionChange: (newSelectedFilters: IFilter[]) => void;
    invertSelection?: boolean;
    labels?: { [key: string]: string };
}

class FilterButtons extends Component<FilterButtonsProps> {
    render() {
        const {filters, selectedFilters} = this.props;
        const selectedIds = selectedFilters.map((filter) => filter.id);
        const handleChange = (event: React.MouseEvent<HTMLElement>, values: string[]) => {
            const {filters, onSelectionChange} = this.props;

            onSelectionChange(filters.filter((f) => values.includes(f.id)));
        }

        return (
            <CustomToggleButtonGroup
                color="primary"
                value={selectedIds}
                onChange={handleChange}
                aria-label="Categories"
            >
                {
                    filters.map(function (filter) {
                        return (
                            <CustomToggleButton
                                key={filter.id}
                                value={filter.id}
                                classes={{
                                    root: `category category-${filter.id}`,
                                    selected: 'selected',
                                }}
                            >
                                {filter.name}
                            </CustomToggleButton>
                        )
                    })
                }
            </CustomToggleButtonGroup>
        )
    }
}

export default FilterButtons;
